<template>
    <div class="details" :class="setError()">
        <div class="item">
            {{ empleado.sequence }}
        </div>
        <div class="item">
            <input type="text" class="nj-text" v-model="empleado.emp_nombre">
        </div>
        <div class="item">
            <input type="text" class="nj-text" v-model="empleado.emp_apellido">
        </div>
        <div class="item">
            <input type="text" class="nj-text" v-model="empleado.emp_dni">
        </div>
        <div class="item">
            <input type="text" class="nj-text" v-model="empleado.emp_celular">
        </div>
        <div class="item">
            <input type="text" class="nj-text" v-model="empleado.emp_email">
        </div>
        <div class="item">
            <select class="nj-select" v-model="empleado.pue_id">
                <option></option>
                <option v-for="item in puestos" :key="item.pue_id" :value="item.pue_id">{{ item.pue_nombre }}</option>
            </select>
        </div>
        <div class="item">
            <button class="nj-button icon c-red" title="Retirar" @click="retirar(empleado.sequence)">
                <i class="mdi mdi-delete"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "EmpleadoCargarItem",
    props: {
        index: {
            type: Number
        },
        empleado: {
            type: Object
        },
        puestos: {
            type: Array
        }
    },
    data() {
        return {

        }
    },
    methods: {
        retirar(sequence) {
            this.$emit("retirar", sequence)
        },
        setError() {
            return this.empleado.emp_error ? "error" : ""
        }
    },
    mounted() {

    }
}
</script>

<style scoped>
.details {
    display: grid;
    grid-template-columns: 40px repeat(7, 1fr);
    align-items: center;
    border-bottom: 1px solid #ccc;
}

.details>.item {
    padding: 6px;
}

.details.error {
    background-color: #ea433580;
}
</style>